import { useEffect, useState } from 'react';
import {
    Grid
} from '@mui/material';
import {
    makeStyles
} from "@mui/styles";
import axios from "axios";
import ClickAwayListener from "react-click-away-listener";
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
    dialpadPopup: {
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: 1,
        backgroundColor: "white"
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0px 2px 4px 5px #D1D1D140",
        padding: "10px"
    },
    callerDisplay: {
        margin: 0,
        display: "flex",
        alignItems: "center",
        fontSize: "14px"
    },
    cursorPointer: {
        cursor: "pointer"
    },
    selectNumberDropdownOptions: {
        backgroundColor: "white",
        boxShadow: "0px 0px 4px 4px #00000014",
        borderRadius: "5px",
        position: "absolute",
        zIndex: 999,
        width: "200px",
        padding: "10px 0px"
    },
    numberOption: {
        padding: "7px 10px",
        cursor: "pointer"
    },
    numberOptionLabel: {
        fontSize: "14px",
        cursor: "pointer",
        width: "100%"
    },
    topBtn: {
        border: "none",
        backgroundColor: "white",
        color: "gray",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "30px",
        marginLeft: "10px",
        cursor: "pointer"
    },
    body: {
        padding: "30px"
    },
    dialpad: {
        backgroundColor: "white",
        border: "1px solid #00000038",
        borderRadius: "10px",
        boxShadow: "0px 0px 5px 0px #00000040",
        overflow: "hidden",
        maxWidth: "400px",
        margin: "auto",
        paddingBottom: "10px"
    },
    dialpadRow: {
        // display: "flex",
        // alignItems: "center",
        // justifyContent: "center"
        marginBottom: "30px",
        padding: "0px 20px"
    },
    top: {
        backgroundColor: "#6765EE",
        color: "white"
    },
    topText: {
        fontSize: "12px",
        fontWeight: "bold"
    },
    dtmfRow: {
        height: "47px",
        borderBottom: "1px solid #00000038"
    },
    dialpadNumberInput: {
        width: "100%",
        margin: "0px",
        padding: "10px",
        fontSize: "22px",
        textAlign: "center"
    },
    dialpadBtn: {
        borderRadius: 0,
        border: 0,
        padding: "20px 30px",
        cursor: "pointer",
        fontSize: "18px",
        backgroundColor: "white",
        width: "100%",
        fontWeight: "bold"
    },
    callBtns: {
        marginTop: "30px !important"
    },
    callBtnView: {

    },
    callBtn: {
        backgroundColor: "#6765EE",
        border: "none",
        color: "white",
        width: "120px",
        padding: "10px",
        borderRadius: "5px",
        fontWeight: "bold",
        boxShadow: "0px 0px 5px 0px #00000040"
    },
    callText: {
        color: "#6765EE",
        margin: "0px",
        marginTop: "5px",
        fontSize: "12px"
    },
    bottom: {
        padding: "0px 30px",
        textAlign: "center"
    },
    bottomText: {
        fontSize: "12px",
        marginBottom: "0px"
    }
});

const Dialpad = ({
    outboundNumber,
    onNumberSelected,
    onCloseDialpad,
    dialCall
}) => {
    const classes = useStyles();

    const [eFoneNumbers, setEfoneNumbers] = useState([]);
    const [numbersDropdownIsVisible, setNumbersDropdownIsVisible] = useState(false);

    const [number, setNumber] = useState("");

    useEffect(() => {
        fetchOutboundNumbers();
    }, []);

    const fetchOutboundNumbers = () => {
        axios
            .get(process.env.REACT_APP_API_URL + "/" + process.env.REACT_APP_API_VERSION + "/eFoneNumbers/assigned/eFone/numbers", {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("userToken")}`
                }
            })
            .then(response => {
                if (response.data) {
                    setEfoneNumbers(response.data?.data);
                }
            })
            .catch(error => {
                console.log("efone numbers error", error);
            });
    }

    const onAllNumbersDropdownBtnClicked = () => {
        setNumbersDropdownIsVisible(!numbersDropdownIsVisible);
    }

    const onOutboundNumberSelected = (number) => {
        setNumbersDropdownIsVisible(false);
        onNumberSelected(number);
    }

    const onDialpadNumberClicked = (digit) => {
        setNumber(number.concat(digit));
    }

    return (
        <Grid className={classes.dialpadPopup}>
            <Grid className={classes.toolbar}>
                <p className={classes.callerDisplay}>
                    Your caller displays as
                    &nbsp;
                    <Grid>
                        <p
                            className={[classes.callerDisplay, classes.cursorPointer].join(" ")}
                            onClick={onAllNumbersDropdownBtnClicked}
                        >
                            {outboundNumber?.phoneNumber || "All Numbers"}
                            &nbsp;
                            <ArrowDropDownCircleIcon />
                        </p>
                        {
                            numbersDropdownIsVisible ?
                                <ClickAwayListener onClickAway={() => setNumbersDropdownIsVisible(false)}>
                                    <Grid className={classes.selectNumberDropdownOptions}>
                                        {
                                            eFoneNumbers?.map((number, i) => {
                                                return (
                                                    <Grid
                                                        onClick={() => onOutboundNumberSelected(number)}
                                                        className={classes.numberOption}
                                                    >
                                                        <label className={classes.numberOptionLabel}>
                                                            <input type="radio" value={number.phoneNumber} checked={outboundNumber?.phoneNumber == number.phoneNumber ? true : false} />&nbsp;{number.phoneNumber}
                                                        </label>
                                                    </Grid>
                                                )
                                            })
                                        }
                                    </Grid>
                                </ClickAwayListener>
                                :
                                <></>
                        }
                    </Grid>
                </p>
                <button
                    onClick={onCloseDialpad}
                    className={classes.topBtn}
                >
                    <CloseIcon />
                </button>
            </Grid>
            <Grid className={classes.body}>
                <Grid className={classes.dialpad}>
                    <Grid className={[classes.dialpadRow, classes.top]}>
                        <Grid
                            container
                            justifyContent={"space-between"}
                        >
                            <p className={classes.topText}>CANADA</p>
                            <p className={classes.topText}>$0.12 USD/min</p>
                        </Grid>
                        <Grid className={classes.dtmfRow}>
                            <p className={classes.dialpadNumberInput}>{number}</p>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={4}>
                            <button
                                className={classes.dialpadBtn}
                                value="1"
                                onClick={() => onDialpadNumberClicked("1")}
                            >1</button>
                        </Grid>
                        <Grid item xs={4}>
                            <button
                                className={classes.dialpadBtn}
                                value="2"
                                onClick={() => onDialpadNumberClicked("2")}
                            >2</button>
                        </Grid>
                        <Grid item xs={4}>
                            <button
                                className={classes.dialpadBtn}
                                value="3"
                                onClick={() => onDialpadNumberClicked("3")}
                            >3</button>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={4}>
                            <button
                                className={classes.dialpadBtn}
                                value="4"
                                onClick={() => onDialpadNumberClicked("4")}
                            >4</button>
                        </Grid>
                        <Grid item xs={4}>
                            <button
                                className={classes.dialpadBtn}
                                value="5"
                                onClick={() => onDialpadNumberClicked("5")}
                            >5</button>
                        </Grid>
                        <Grid item xs={4}>
                            <button
                                className={classes.dialpadBtn}
                                value="6"
                                onClick={() => onDialpadNumberClicked("6")}
                            >6</button>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={4}>
                            <button
                                className={classes.dialpadBtn}
                                value="7"
                                onClick={() => onDialpadNumberClicked("7")}
                            >7</button>
                        </Grid>
                        <Grid item xs={4}>
                            <button
                                className={classes.dialpadBtn}
                                value="8"
                                onClick={() => onDialpadNumberClicked("8")}
                            >8</button>
                        </Grid>
                        <Grid item xs={4}>
                            <button
                                className={classes.dialpadBtn}
                                value="9"
                                onClick={() => onDialpadNumberClicked("9")}
                            >9</button>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={4}>
                            <button
                                className={classes.dialpadBtn}
                                value="*"
                                onClick={() => onDialpadNumberClicked("*")}
                            >*</button>
                        </Grid>
                        <Grid item xs={4}>
                            <button
                                className={classes.dialpadBtn}
                                value="0"
                                onClick={() => onDialpadNumberClicked("0")}
                            >0</button>
                        </Grid>
                        <Grid item xs={4}>
                            <button
                                className={classes.dialpadBtn}
                                value="#"
                                onClick={() => onDialpadNumberClicked("#")}
                            >#</button>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        alignItems={"center"}
                        spacing={2}
                        className={classes.callBtns}
                    >
                        <Grid
                            item
                            container
                            justifyContent={"flex-end"}
                            xs={6}
                            className={classes.callBtnView}
                        >
                            <Grid textAlign={"center"}>
                                <button
                                    className={classes.callBtn}
                                    onClick={() => dialCall(1, number, outboundNumber?.phoneNumber, number)}
                                >eFone Call</button>
                                <p className={classes.callText}>0$/Free</p>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            container
                            xs={6}
                            className={classes.callBtnView}
                        >
                            <Grid textAlign={"center"}>
                                <button
                                    className={classes.callBtn}
                                    onClick={() => dialCall(2, number, outboundNumber?.phoneNumber, number)}
                                >Call</button>
                                <p className={classes.callText}>12.3$</p>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid className={classes.bottom}>
                        <p className={classes.bottomText}>You can subscribe to <Link to="/dashboard" className={classes.bottomText}>International call</Link> add-on in order lower the call cost.$2 will charge for this call by subscribing to add-ons.</p>
                        <Link
                            to={"/dashboard"}
                            className={classes.bottomText}
                        >Subscribe Now</Link>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Dialpad;